import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordionGalleryBlock, LazyAdvantagesBlock, LazyBannerCollectionsBlock, LazyContactsBlock, LazyFormBlock, LazyHeadingBlock, LazyHtmlBlock, LazyLastSeenProductsBlock, LazyLinksListBlock, LazyLinksWithImagesBlock, LazyProjects3DListBlock, LazyReviewsBlock, LazySelectProductsBlock, LazyShareBlock, LazySpaceBlock, LazyStoresBlock, LazySubscribeBlock, LazyTitleBlock, LazyTwoColumnsBlock, LazyVideoBlock, LazyNewAccordionGalleryBlock, LazyBannerPlaceholder, LazyMainLayout, LazyCmsBlockMixin, LazyCmsPage, LazyCarouselBlock, LazyCkEditorBlock, LazyContainerBlock, LazyGridBlock, LazyImageBlock, LazySectionBlock, LazySpecialBlock, LazyLayoutPlaceholder, LazyHeaderNavItem, LazyTestHeaderNav, LazyPopupGallery, LazySearchInput, LazyLazySearchDropdown, LazySearchInputBody, LazySearchInputTop, LazyArticles, LazyBrands, LazyCategories, LazyProductCard, LazyProducts, LazyService, LazyVideos, LazyComponent, LazyAddToCardBtn, LazyProductCardTemplate, LazyProductPageTemplate, LazyPagination } from '#components'
const lazyGlobalComponents = [
  ["AccordionGalleryBlock", LazyAccordionGalleryBlock],
["AdvantagesBlock", LazyAdvantagesBlock],
["BannerCollectionsBlock", LazyBannerCollectionsBlock],
["ContactsBlock", LazyContactsBlock],
["FormBlock", LazyFormBlock],
["HeadingBlock", LazyHeadingBlock],
["HtmlBlock", LazyHtmlBlock],
["LastSeenProductsBlock", LazyLastSeenProductsBlock],
["LinksListBlock", LazyLinksListBlock],
["LinksWithImagesBlock", LazyLinksWithImagesBlock],
["Projects3DListBlock", LazyProjects3DListBlock],
["ReviewsBlock", LazyReviewsBlock],
["SelectProductsBlock", LazySelectProductsBlock],
["ShareBlock", LazyShareBlock],
["SpaceBlock", LazySpaceBlock],
["StoresBlock", LazyStoresBlock],
["SubscribeBlock", LazySubscribeBlock],
["TitleBlock", LazyTitleBlock],
["TwoColumnsBlock", LazyTwoColumnsBlock],
["VideoBlock", LazyVideoBlock],
["NewAccordionGalleryBlock", LazyNewAccordionGalleryBlock],
["BannerPlaceholder", LazyBannerPlaceholder],
["MainLayout", LazyMainLayout],
["CmsBlockMixin", LazyCmsBlockMixin],
["CmsPage", LazyCmsPage],
["CarouselBlock", LazyCarouselBlock],
["CkEditorBlock", LazyCkEditorBlock],
["ContainerBlock", LazyContainerBlock],
["GridBlock", LazyGridBlock],
["ImageBlock", LazyImageBlock],
["SectionBlock", LazySectionBlock],
["SpecialBlock", LazySpecialBlock],
["LayoutPlaceholder", LazyLayoutPlaceholder],
["HeaderNavItem", LazyHeaderNavItem],
["TestHeaderNav", LazyTestHeaderNav],
["PopupGallery", LazyPopupGallery],
["SearchInput", LazySearchInput],
["LazySearchDropdown", LazyLazySearchDropdown],
["SearchInputBody", LazySearchInputBody],
["SearchInputTop", LazySearchInputTop],
["Articles", LazyArticles],
["Brands", LazyBrands],
["Categories", LazyCategories],
["ProductCard", LazyProductCard],
["Products", LazyProducts],
["Service", LazyService],
["Videos", LazyVideos],
["Component", LazyComponent],
["AddToCardBtn", LazyAddToCardBtn],
["ProductCardTemplate", LazyProductCardTemplate],
["ProductPageTemplate", LazyProductPageTemplate],
["Pagination", LazyPagination],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
